import { render } from "./Carina.vue?vue&type=template&id=33de855a&ts=true"
import script from "./Carina.vue?vue&type=script&lang=ts"
export * from "./Carina.vue?vue&type=script&lang=ts"

import "./Carina.vue?vue&type=style&index=0&id=33de855a&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__